import { createAppThemeModule } from './app-theme-runtime';

const ThemeModule = createAppThemeModule({
	appId: 'association',
	storageKey: 'YouEvent365_association.theme.palette',
	defaultThemeKey: 'pearl-sky',
});

export default ThemeModule;
